exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.pathname === `/coachs-corner/`) {
    return false
  }

  return true
}
